import React, { useEffect, useState } from "react";
import product_img from "../../assets/product_img.png";
import {
  Button,
  Card,
  Col,
  Form,
  Row,
  Select,
  Spin,
  Tag,
  Typography,
} from "antd";
import { CameraOutlined, PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getStoreByIdAsync,
  updateStoreStatusAsync,
} from "../../services/StoreManagementServices";
import { asyncStatus } from "../../utils/asyncStatus";
import { getOderByIdAsync } from "../../services/OrderManagementService";

const { Title, Text } = Typography;
const { Item } = Form;
const { Option } = Select;

const OrderDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [storeStatus, setStoreStatus] = useState("");
  const {
    get_order_by_id_data,
    get_order_by_id_status,
    update_store_status_status,
    update_store_status_data,
  } = useSelector((state) => state.orderManagement);

  const storeLoader = get_order_by_id_status === asyncStatus.LOADING;
  const updateStoreStatusLoader =
    update_store_status_status === asyncStatus.LOADING;

  useEffect(() => {
    if (Object.keys(get_order_by_id_data?.store || {})?.length > 0) {
      setStoreStatus(get_order_by_id_data?.store?.status);
    }
  }, [get_order_by_id_data]);

  const _handleStoreStatus = () => {
    const statusObj = {
      storeId: id,
      status: storeStatus,
    };

    dispatch(updateStoreStatusAsync(statusObj));
  };

  const orderStatus = [
    { status: "pending", clr: "gold" },
    { status: "shipped", clr: "blue" },
    { status: "delivered", clr: "green" },
    
  ];


  console.log("orderdetail page  ")

  const statusObj = orderStatus.find(
    (item) => item.status === get_order_by_id_data?.orderStatus
  );

  useEffect(() => {
    dispatch(getOderByIdAsync(id));
  }, []);

  if (storeLoader) {
    return (
      <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
        <div className="flex items-center justify-center h-[40vh]">
          <Spin size="large" className="flex justify-center" />
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center">
      <Card className="max-w-7xl mx-auto w-full shadow-lg rounded-xl overflow-hidden p-2">
        <Row gutter={24}>
          {/* Right Side - Live Store Preview */}
          <Col xs={24} md={24} className="p-2">
            <div className="bg-gray-100 p-4 rounded-lg shadow-md">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>
                  <Title level={4}>Live Order Preview</Title>
                </div>

                {/* <Select
                      size="middle"
                      //   defaultValue={
                      //     storeStatus || get_order_by_id_data?.orderStatus
                      //   }
                      defaultValue={get_order_by_id_data?.orderStatus}
                      onChange={(e) => setStoreStatus(e)}
                    >
                      <Option value="Active">Active</Option>
                      <Option value="Inactive">Inactive</Option>
                    </Select> */}

                <div>
                  {get_order_by_id_data?.orderStatus && (
                    <Tag color={statusObj ? statusObj.clr : "red"}>
                      {statusObj ? statusObj.status.toUpperCase() : "UNKNOWN"}
                    </Tag>
                  )}
                </div>
              </div>
              <div className="mt-3 flex flex-col gap-1">
                <div className="flex flex-col items-start gap-4">
                  <div className="flex flex-col items-start ">
                    <Title level={5}>
                      Orders ID : {get_order_by_id_data?.order_id || "0"}
                    </Title>
                    <Text>
                      Orders Items:{" "}
                      {get_order_by_id_data?.order_items?.length || "0"}
                    </Text>
                  </div>

                  <div className="flex items-center justify-start flex-wrap gap-4 ">
                    {get_order_by_id_data?.order_items?.map((item, index) => {
                      return (
                        <div className="bg-gray-50 p-3 rounded-md shadow-md gap-5">
                          <div className="flex justify-between items-center gap-10">
                            <Text strong>
                              Product name: {item?.product_id?.name || "-"}
                            </Text>

                            <Text strong>
                              Stores :{" "}
                              {item?.store_ids
                                ?.map(({ name }) => name)
                                ?.join(", ") || "-"}
                            </Text>
                          </div>

                          <div className="flex flex-col gap-1 mt-3">
                            {item?.product_id?.images?.map((imgs, i) => {
                              return (
                                <div className="w-16 h-16 rounded-lg border-2 overflow-hidden">
                                  <img
                                    src={imgs || ""}
                                    alt="Store Logo"
                                    className="w-full h-full object-cover"
                                  />
                                </div>
                              );
                            })}
                          </div>

                          <div className="flex flex-col gap-1 mt-5">
                            <Text strong>
                              SKU: {item?.product_id?.sku || "0"}
                            </Text>
                            <Text strong>
                              Quantity: {item?.quantity || "0"}
                            </Text>

                            <div className="flex flex-col gap-1 mt-2">
                              <Text strong style={{ fontSize: "20px" }}>
                                Variant
                              </Text>
                              <div className="flex flex-col mt-2">
                                <Text>
                                  Fabric :{" "}
                                  {item?.selectedVariant?.fabric || "0"}
                                </Text>
                                <Text>
                                  Finishing:{" "}
                                  {item?.selectedVariant?.finishing || "0"}
                                </Text>
                                <Text>
                                  Size: {item?.selectedVariant?.size || "0"}
                                </Text>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <Text>
                    Payment Method :{" "}
                    {get_order_by_id_data?.paymentMethod || "-"}
                  </Text>
                  <Text>
                    Sub Total : {get_order_by_id_data?.subtotal || "-"}
                  </Text>
                  <Text>
                    Tax Amount : {get_order_by_id_data?.taxAmount || "-"}
                  </Text>
                  <Text>
                    Total Amount : {get_order_by_id_data?.totalAmount || "-"}
                  </Text>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default OrderDetail;
